export default __webpack_public_path__ + "static/media/logo.bfa11610.png";